<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Subadmins",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Subadmins",
      items: [
        {
          text: "Subadmins",
          active: true,
        },
      ],

      listing_length: 10,
      keyword: "",

      sub_admins: [],
      sub_admin: {
        id: null,
        user_id: null,
        name_en: "",
        name_so: "",
        email: "",
        password: "",
                status: "",

      },

      modal_title: "Add Subadmin",
      button_title: "Save",
      from: null,
      to: null,
      total: null,
      pagination: {},
      edit: false,
      sub_admin_status: {
        id: "",
        status: "",
      },

      status: "",

      token: "",
      errors: {},
      activate: false,
      deactivate: false,

      active_page_url: null,

      password: '',
      password_confirmation: '',

    };
  },
  mounted() {},

  created() {
    this.fetchSubAdmins();
  },

  methods: {
    fetchSubAdmins(page_url = null) {
      this.getToken();
      let url =
        "api/admin/sub_admins?keyword=" +
        this.keyword +
        "&limit=" +
        this.listing_length +
        "&status=" +
        this.status;

      page_url = page_url || url;

      if (localStorage.back_url) {
        page_url = localStorage.back_url;
        localStorage.removeItem("back_url");
      }

      this.active_page_url = page_url;
      this.loading = true;

      this.$axios
        .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
        .then((res) => {
          if (res.status == 200) {
            var responseData = res.data.data;
            console.log(responseData);
            this.sub_admins = responseData.subadmin.data;

            this.pagination = responseData.subadmin.links;
            this.from = responseData.subadmin.from;
            this.to = responseData.subadmin.to;
            this.total = responseData.subadmin.total;
          } else {
            this.$swal("", "Something went wrong", "error");
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 422) {
              if (error.response.data) {
                this.errors = error.response.data.message;
              }
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 401) {
              this.$swal("", error.response.statusText, "error");
              this.$router.push({ name: "login" });
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        })
        .finally(() => (this.loading = false));
    },

    getToken() {
      if (localStorage.getItem("sigofuel_admin")) {
        var sigofuel_admin = JSON.parse(localStorage.getItem("sigofuel_admin"));
        if (sigofuel_admin.token) {
          this.token = sigofuel_admin.token;
        } else {
          this.$swal("", "Failed to fetch token, please login again", "error");
          this.$router.push({ name: "login" });
        }
      } else {
        this.$swal("", "Session expired, please login again", "error");
        this.$router.push({ name: "login" });
      }
    },

    showModal(modal) {
      this.$refs[modal].show();
    },

    hideModal(modal) {
      this.$refs[modal].hide();
    },

    editSubAdmin(sub_admin) {
      this.modal_title = "Edit Subadmin";
      this.button_title = "Update";
      this.sub_admin.id = sub_admin.id;
      this.sub_admin.name_en = sub_admin.name_en;
      this.sub_admin.name_so = sub_admin.name_so;
      this.sub_admin.email = sub_admin.email;

      this.edit = true;
      this.showModal("admin-modal");
    },

    addSubAdmin() {
      this.getToken();

      const config = {
        headers: {
          "Content-type": "multipart/form-data",
          Accept: "application/json",
          Authorization: "Bearer " + this.token,
        },
      };

      let url;
      let formData = new FormData();

      if (!this.edit) {
        url = "api/admin/sub_admin/add";
        this.active_page_url = null;
        formData.append("password", this.sub_admin.password);
        formData.append(
          "password_confirmation",
          this.sub_admin.password_confirmation
        );
      } else {
        url = "api/admin/sub_admin/edit";
        formData.append("id", this.sub_admin.id);
      }

      if (this.sub_admin.name_en) {
        formData.append("name_en", this.sub_admin.name_en);
      } else {
        formData.append("name_en", "");
      }
      if (this.sub_admin.name_so) {
        formData.append("name_so", this.sub_admin.name_so);
      } else {
        formData.append("name_so", "");
      }
      formData.append("email", this.sub_admin.email);

      this.loading = true;

      this.$axios
        .post(url, formData, config)
        .then((response) => {
          if (response.status == 200) {
            this.$swal("", response.data.message, "success");
          }

          this.hideModal("admin-modal");
          this.fetchSubAdmins(this.active_page_url);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 422) {
              if (error.response.data) {
                this.errors = error.response.data.message;
              }
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        })
        .finally(() => (this.loading = false));
    },
    clearForm() {
      this.modal_title = "Add Subadmin";
      this.button_title = "Add";
      this.sub_admin.id = "";
      this.sub_admin.name_en = "";
      this.sub_admin.name_so = "";
      this.sub_admin.email = "";
      this.sub_admin.password = "";
      this.sub_admin.confirm_password = "";
      this.edit = false;
      this.errors = {};
    },

    set_id(sub_admin) {
      this.sub_admin.user_id = sub_admin.user_id;
      this.showModal("password-modal");
    },
    
    changePassword() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/sub_admin/change_password";
            let formData = new FormData();
            formData.append("user_id", this.sub_admin.user_id); 
            formData.append("password", this.password); 
            formData.append("password_confirmation", this.password_confirmation); 
            
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('password-modal');
               })
                .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },


    activateSubAdmin(sub_admin) {
      this.activate = false;
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to publish this subadmin?", {
          title: "Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.activate = value;
          if (this.activate) {
            this.sub_admin_status.id = sub_admin.id;
            this.sub_admin_status.status = 1;
            this.updateSubAdminStatus();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deactivateSubAdmin(sub_admin) {
      this.deactivate = false;
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to unpublish this subadmin?", {
          title: "Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.deactivate = value;
          if (this.deactivate) {
            this.sub_admin_status.id = sub_admin.id;
            this.sub_admin_status.status = 2;
            this.updateSubAdminStatus();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateSubAdminStatus() {
      this.getToken();
      const config = {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + this.token,
        },
      };

      /* var formData = JSON.stringify({
               "id": this.sub_admin_status.id,
               "status": this.sub_admin_status.status
            });
 */

      let url =
        "api/admin/sub_admin/status?id=" +
        this.sub_admin_status.id +
        "&status=" +
        this.sub_admin_status.status;

      this.$axios
        .get(url, config)
        .then((response) => {
          if (response.data.status) {
            this.$swal("", response.data.message, "success");
          } else {
            this.$swal("", response.data.message, "error");
          }
          this.fetchSubAdmins(this.active_page_url);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.message) {
              this.$swal("", error.response.data.message, "error");
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", "Something went wrong", "error");
          }
        });
    },
  }
}
</script>
    
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

            <!----- top button area starts---->
            <div class="row mb-3">
              <div class="col-12">
                <b-button
                  v-b-modal.admin-modal
                  variant="primary"
                  class="float-end"
                  >Add Subadmin</b-button
                >
              </div>
            </div>
            <!----- top button area ends---->

            <!----- Listing length and search starts ----->
            <div class="row mb-3">
              <div class="col-sm-12 col-md-6">
                <div class="listing-length">
                  <label
                    >Show
                    <select
                      class="form-control"
                      v-model="listing_length"
                      @change="fetchSubAdmins()"
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                    </select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="listing-filter">
                  <label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search"
                      v-model="keyword"
                      @keyup="fetchSubAdmins()"
                    />
                  </label>
                </div>
                <div class="listing-filter me-2">
                  <label>
                    <select
                      class="form-control"
                      v-model="status"
                      @change="fetchSubAdmins()"
                    >
                      <option value="">All</option>
                      <option value="1">Published</option>
                      <option value="2">Unpublished</option>
                    </select>
                  </label>
                </div>
              </div>
            </div>
            <!----- Listing length and search ends ----->

            <!---- listing table starts -------->
            <div class="table-responsive">
              <table class="table table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th>SI. No.</th>

                    <th>Name (English)</th>
                    <th>Name (Somali)</th>
                    <th>Email</th>
                    <th>Status</th>

                    <th>Created On</th>
                    <th>Options</th>
                  </tr>
                </thead>
                <tbody v-if="Boolean(sub_admins.length)">
                  <tr
                    v-for="(sub_admin, index) in sub_admins"
                    :key="sub_admin.id"
                  >
                    <td>{{ index + from }}</td>
                    <td>{{ sub_admin.name_en }}</td>
                    <td>{{ sub_admin.name_so }}</td>
                    <td>{{ sub_admin.email }}</td>

                    <td>
                      <span
                        v-if="sub_admin.status == 1"
                        class="badge rounded-pill bg-success"
                        >Active</span
                      >
                      <span
                        v-if="sub_admin.status == 2"
                        class="badge rounded-pill bg-danger"
                        >Blocked</span
                      >
                    </td>
                    <td>{{ sub_admin.converted_created_at }}</td>
                    <td>
                                                     
               <router-link :to="{ name: 'subadmins.settings',params: {id: sub_admin.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Settings</router-link>  

                      <b-button
                        variant="primary"
                        class="btn-sm mb-2 me-2"
                        @click="editSubAdmin(sub_admin)"
                        >Edit</b-button
                      >

                      <b-button
                        v-if="sub_admin.status == 1"
                        variant="danger"
                        class="btn-sm mb-2 me-2"
                        @click="deactivateSubAdmin(sub_admin)"
                        >Unpublish</b-button
                      >
                      <b-button
                        v-else
                        variant="success"
                        class="btn-sm mb-2 me-2"
                        @click="activateSubAdmin(sub_admin)"
                        >Publish</b-button
                      >

                      <!-- <b-button v-if="sub_admin.role_id == 2" v-b-modal.password-modal block variant="primary" class="btn-sm mb-2 me-2">Change Password</b-button> -->
                      <b-button v-if="sub_admin.role_id == 2" v-b-modal.password-modal block variant="primary" class="btn-sm mb-2 me-2"  @click="set_id(sub_admin)">Change Password</b-button>

                        
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" class="text-center">No subadmins found</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!---- listing table ends -------->

            <!----pagination starts --->
            <caption
              v-if="Boolean(sub_admins.length)"
              class="float-start mt-4 d-block d-lg-inline"
            >
              Showing
              {{
                this.from
              }}
              to
              {{
                this.to
              }}
              of
              {{
                this.total
              }}
              entries
            </caption>
            <ul
              class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex"
            >
              <li
                class="page-item"
                v-bind:class="[
                  { disabled: !page.url },
                  { active: page.active },
                ]"
                v-for="(page, index) in pagination"
                :key="page.label"
              >
                <a
                  href="#"
                  class="page-link"
                  @click.prevent="
                    fetchSubAdmins(
                      page.url +
                        '&limit=' +
                        listing_length +
                        '&keyword=' +
                        keyword +
                        '&status=' +
                        status
                    )
                  "
                >
                  <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                  <i
                    v-else-if="index == pagination.length - 1"
                    class="mdi mdi-chevron-right"
                  ></i>
                  <span v-else>{{ page.label }}</span>
                </a>
              </li>
            </ul>
            <!----pagination ends --->

            <!---- modal starts ---->
            <b-modal
              ref="admin-modal"
              id="admin-modal"
              :title="modal_title"
              hide-footer
              @hidden="clearForm()"
            >
              <b-form @submit.prevent="addSubAdmin()">
                <div class="row">
                  <b-form-group class="col-lg-12">
                    <label
                      >Name (English) <span class="text-danger">*</span></label
                    >
                    <b-form-input
                      v-model="sub_admin.name_en"
                      :class="{ 'is-invalid': Boolean(errors.name_en) }"
                    ></b-form-input>

                    <div
                      v-for="(val, index) in errors.name_en"
                      :key="index"
                      class="invalid-feedback"
                    >
                      <p class="mb-0">{{ val }}</p>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-lg-12">
                    <label
                      >Name (Somali) <span class="text-danger">*</span></label
                    >
                    <b-form-input
                      v-model="sub_admin.name_so"
                      :class="{ 'is-invalid': Boolean(errors.name_so) }"
                    ></b-form-input>

                    <div
                      v-for="(val, index) in errors.name_so"
                      :key="index"
                      class="invalid-feedback"
                    >
                      <p class="mb-0">{{ val }}</p>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-lg-12 mb-3">
                    <label>Email <span class="text-danger">*</span></label>
                    <b-form-input
                      type="email"
                      v-model="sub_admin.email"
                      v-bind:class="{ 'is-invalid': Boolean(errors.email) }"
                      autocomplete="off"
                    ></b-form-input>

                    <div
                      v-for="(val, index) in errors.email"
                      :key="index"
                      class="invalid-feedback"
                    >
                      <p class="mb-0">{{ val }}</p>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-lg-6 mb-3" v-if="!edit">
                    <label>Password <span class="text-danger">*</span></label>
                    <b-form-input
                      type="password"
                      v-model="sub_admin.password"
                      v-bind:class="{ 'is-invalid': Boolean(errors.password) }"
                    ></b-form-input>

                    <div
                      v-for="(val, index) in errors.password"
                      :key="index"
                      class="invalid-feedback"
                    >
                      <p class="mb-0">{{ val }}</p>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-lg-6 mb-3" v-if="!edit">
                    <label
                      >Confirm Password
                      <span class="text-danger">*</span></label
                    >
                    <b-form-input
                      type="password"
                      v-model="sub_admin.password_confirmation"
                      v-bind:class="{
                        'is-invalid': Boolean(errors.password_confirmation),
                      }"
                    ></b-form-input>

                    <div
                      v-for="(val, index) in errors.password_confirmation"
                      :key="index"
                      class="invalid-feedback"
                    >
                      <p class="mb-0">{{ val }}</p>
                    </div>
                  </b-form-group>

                  <b-col md="12" class="mt-3">
                    <b-button type="submit" class="me-3" variant="primary">{{
                      button_title
                    }}</b-button>
                    <b-button
                      class=""
                      variant="light"
                      @click="hideModal('admin-modal')"
                      >Close</b-button
                    >
                  </b-col>
                </div>
              </b-form>
            </b-modal>

            <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
              <b-form @submit.prevent="changePassword()">
                  <b-row>  
                    <b-col lg="12" class="form-group">
                        <label class="control-label">New Password <span class="text-danger">*</span></label>
                        <b-form-input type="password" v-model="password"></b-form-input>

                        <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>

                    </b-col>  

                    <b-col lg="12" class="form-group">
                        <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                        <b-form-input type="password" v-model="password_confirmation"></b-form-input>

                        <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
      
                    </b-col>    
                    
                    <b-col lg="12">
                        <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                        <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
                    </b-col>
                  </b-row>
              </b-form>
            </b-modal>
            <!---- modal ends ----->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
